const strStartWith = (str1, str2) =>
  str1
    .toLowerCase()
    .trim()
    .startsWith(str2.toLowerCase().trim())

const strEquals = (str1, str2) =>
  str1.toLowerCase().trim() === str2.toLowerCase().trim()

const match = (searchingArray, entries) => {
  return searchingArray.reduce((acc, str, index) => {
    const matched =
      index === searchingArray.length - 1 ? strStartWith : strEquals
    return acc && entries.some(entry => matched(entry, str))
  }, true)
}

export const filter = (products, searchingStr) => {
  const searchingArray = searchingStr.split(' ')
  const filtered = products.filter(product => {
    const entries = product.value.technicalLabel.split(' ')
    return match(searchingArray, entries)
  })
  return filtered
}



// WEBPACK FOOTER //
// ./src/services/filter.js